// Collection.js
// Main creations page displaying editorial-style article stories.
// Fetches article data on mount using useArticle hook.
// Each article opens in a modal popup when clicked.

import React, { useEffect } from 'react';
import './Collection.css';
import { Link } from 'react-router-dom';

import Header from '../../../components/common/Header/header';
import CollectionItem from '../../../components/ui/CollectionItem/collectionItem';
import { useArticle } from '../../../hooks/useArticle';
import ErrorDisplay from '../../../components/common/Error/Error';

const Collection = () => {
    const { articles, loading, error, fetchArticles } = useArticle();

    useEffect(() => {
        fetchArticles();
    }, [fetchArticles]);

    return (
<div className="collection-container">

        <div className="collection-header">
            <Header />
        </div>

        <div className="collection-content">
            <div className="collection-title">
                <h1>Articles</h1>
            </div>

            <p className="collection-intro">
                Une sélection d’articles, d’histoires et de détails de création.
            </p>

            {!loading && !error && articles && articles.length > 0 ? (
                <div className="collection-items">
                    {articles.map((item, index) => (
                        <CollectionItem
                            key={item.id}
                            article={item}
                            index={index}
                        />
                    ))}
                </div>
            ) : (
                <div className="collection-empty-state">
                    {loading && <div>Chargement...</div>}

                    {error && (
                        <ErrorDisplay errorData={error} />
                    )}

                    {!loading &&
                        !error &&
                        (!articles || articles.length === 0) && (
                            <>
                                <h2>Articles non disponibles</h2>
                                <p>
                                    Les prochains articles seront publiés bientôt.
                                </p>
                                <p>
                                    Veuillez revenir ultérieurement.
                                </p>
                            </>
                        )}
                </div>
            )}
        </div>

        <footer>
            <Link to="/legal-mention">
                Mentions légales
            </Link>
        </footer>

    </div>
    );
};

export default Collection;
